import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AuthContext from '../../store/auth-context';
import { Button } from '../ui/button';

export default function NoAccess() {
    const { t } = useTranslation();
    const { onLogout } = useContext(AuthContext);
    return (
        <div className="flex min-h-screen items-center justify-center bg-background px-6">
            <div className="max-w-md text-center">
                <h1 className="text-lg font-semibold text-foreground">
                    {t('onboarding.noAccess.title')}
                </h1>
                <p className="mt-2 text-sm text-muted-foreground">
                    {t('onboarding.noAccess.description')}
                </p>
                <Button
                    variant="outline"
                    size="sm"
                    className="mt-6"
                    onClick={onLogout}
                >
                    {t('onboarding.noAccess.backToLogin')}
                </Button>
            </div>
        </div>
    );
}
